import { PlanInfoBadge } from "components/views/planinfo/PlanInfoBadge"
import React, { FC } from "react"
import L10n from "lib/carrot-l10n"
import { useSelector } from "react-redux"
import { getHasDeductible } from "derivedSelectors/deductibleSelectors"
import { getHasCostShare } from "derivedSelectors"
import { useFeatureToggle } from "../../context/feature-toggle/FeatureToggleContext"
import { COMPANY_DEDUCTIBLE_STATUS, CSD_CONFIGURATION, useUserDeductible } from "../../context/user/DeductibleContext"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

interface PlanInfoBadgeContainerProps {
  backgroundColor: string
  fontColor: string
}

const PlanInfoBadgeContainer: FC<PlanInfoBadgeContainerProps> = ({ backgroundColor, fontColor }) => {
  const { showNewEnrollmentFlow: showUpdatedDeductibleInfo } = useFeatureToggle()
  const { companyDeductibleStatus, csdConfiguration } = useUserDeductible()
  const companyHasExternalDeductible = companyDeductibleStatus === COMPANY_DEDUCTIBLE_STATUS.EXTERNAL
  const companyHasCSD = companyDeductibleStatus === COMPANY_DEDUCTIBLE_STATUS.CARROT_SPECIFIC_DEDUCTIBLE
  const hasCSD = companyHasCSD && csdConfiguration !== CSD_CONFIGURATION.NEITHER
  const hasCostShare = useSelector(getHasCostShare)
  const hasDeductible = useSelector(getHasDeductible)
  const shouldShowDeductibleOrCostShareLink = companyHasExternalDeductible || hasCostShare || (companyHasCSD && hasCSD)
  const getTextFromUserDeductibleAndCostShare = (
    hasCostShare: boolean,
    companyHasExternalDeductible: boolean,
    hasCSD: boolean
  ) => {
    if (hasCostShare && (hasCSD || companyHasExternalDeductible)) {
      return l`Deductible & cost-sharing apply`
    }
    if (hasCostShare) {
      return l`Cost-sharing applies`
    }
    if (hasCSD || companyHasExternalDeductible) {
      return l`Deductible applies`
    }
    return null
  }

  const getTextFromPlanInfo = (hasCostShare: boolean, hasDeductible: boolean) => {
    if (hasCostShare && hasDeductible) {
      return l`Deductible & cost-sharing apply`
    }
    if (hasCostShare) {
      return l`Cost-sharing applies`
    }
    if (hasDeductible) {
      return l`Deductible applies`
    }
    return null
  }

  return showUpdatedDeductibleInfo
    ? shouldShowDeductibleOrCostShareLink && (
        <PlanInfoBadge backgroundColor={backgroundColor} fontColor={fontColor}>
          {getTextFromUserDeductibleAndCostShare(hasCostShare, companyHasExternalDeductible, hasCSD)}
        </PlanInfoBadge>
      )
    : (hasCostShare || hasDeductible) && (
        <PlanInfoBadge backgroundColor={backgroundColor} fontColor={fontColor}>
          {getTextFromPlanInfo(hasCostShare, hasDeductible)}
        </PlanInfoBadge>
      )
}

export { PlanInfoBadgeContainer }
